import React from "react";
import {ClientReportFile} from "./domain";
import {ClientReportFileColumns} from "./ClientReportFileTable";
import {Link} from "evergreen-ui";
import {ModalTooltip} from "../../common/component/ModalTooltip";

type ClientReportFileListRowItemProps = {
    file: ClientReportFile;
    onDelete?: (fileGuid: string) => Promise<void>;
    deleteDisabledReason?: string | null;
}

export function ClientReportFileListRowItem({file, onDelete, deleteDisabledReason}: ClientReportFileListRowItemProps) {
    const selected = false;
    const isDeleteDisabled = !!deleteDisabledReason;
    return (
        <tr className={`border-b text-xs border-gray-200 hover:${selected ? 'bg-botticelli-100' : 'bg-gray-200'} ${selected ? 'bg-botticelli-100 text-white' : ''}`}>
            {
                ClientReportFileColumns.map((column) => (
                    <td
                        key={column.name}
                        className={'py-5' + (column.attr === 'fileName' ? ' pl-4' : '')}
                    >
                        {
                            column.attr === 'fileName' ?
                                <Link target="_blank" rel="noopener" href={file.downloadUrl}>
                                    <span className="text-blue-portal-link">
                                        {file.fileName}
                                    </span>
                                </Link> :
                                column.attr === 'fileExtension' ? file.fileExtension.toUpperCase() : file[column.attr]
                        }
                    </td>
                ))
            }
            {onDelete && (
                <td className="py-2 pr-2 text-right">
                    <div className="flex items-center justify-end gap-1">
                        <button
                            type="button"
                            disabled={isDeleteDisabled}
                            onClick={() => onDelete(file.guid)}
                            className={`text-xs font-medium rounded px-4 py-2 transition-colors focus:outline-none ${
                                isDeleteDisabled
                                    ? 'border border-gray-300 text-gray-400 bg-gray-100 cursor-not-allowed select-none'
                                    : 'border border-red-400 text-red-500 hover:bg-red-500 hover:text-white hover:border-red-500'
                            }`}
                        >
                            Delete
                        </button>
                        {isDeleteDisabled && deleteDisabledReason && (
                            <ModalTooltip
                                content={deleteDisabledReason}
                                position="right"
                            />
                        )}
                    </div>
                </td>
            )}
        </tr>
    )

}
